import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const OnboardingContainer = styled.div`
  display: flex;

  width: 100%;
  height: 100dvh;

  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const RightPanelWrapper = styled.div`
  width: 50%;
  display: none;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 50%;
  }
`;

export const LeftPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  min-height: 0;
  width: 100%;
  max-width: ${({ theme }) => `calc(34.4rem + ${theme.spacing(8)})`};
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(4)} 0`};
  margin: 0 auto;
`;

export const RightPanel = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};
  overflow: hidden;
`;

export const RightPanelImage = styled.img`
  position: absolute;

  top: 50%;
  left: 20%;
  max-width: 665px;

  transform: translateY(-50%);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  padding: ${({ theme }) => `${theme.spacing(6)}`};
  margin: ${({ theme }) => `-${theme.spacing(6)}`};

  overflow-y: auto;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Subtitle = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const TasksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const FooterArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `0 0 ${theme.spacing(2)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Chip = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1.5)}`};
  margin: 0;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.grey[100]};
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1.2rem;
`;

export const ChipLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const TaskRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(2)}`};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(2)};

  white-space: nowrap;
  overflow: hidden;
`;

export const TaskRowControl = styled.div`
  min-width: 0;
`;

export const Input = styled.input`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};

  flex: 2 1 0;
  min-width: 12rem;
  max-width: 100%;

  border: none;
  background: transparent;
  outline: transparent;
`;
